var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awareness-banner"},[_c('div',{staticClass:"awareness-banner__image-container"},[(_vm.image)?_c('img',{staticClass:"awareness-banner__image",attrs:{"src":_vm.image}}):_vm._e()]),_c('div',{staticClass:"awareness-banner__main-column"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }